import React from 'react'
import Grid from '@material-ui/core/Grid';

import './index.css'

const HeaderPage = ({ text }) => {
  return (
    <Grid className="header-page" xs item>
      <span className="header-page-text">{text}</span>
    </Grid>
  )
}

export default HeaderPage